<div class="invite-dialog">

    <ng-container *ngIf="isSent">
        <div class="success-screen">
            <i class="material-icons success-icon">mark_email_read</i>
            <h3>Invitation Sent!</h3>
            <p>Invitation sent to <strong>{{ inviteForm.get('email')?.value }}</strong>
                as <strong>{{ selectedRole?.label }}</strong>.
            </p>
            <div class="success-actions">
                <button class="btn-cancel" (click)="onResend()">Send Another</button>
                <button class="btn-send" (click)="onClose()">Done</button>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="isError">
        <div class="error-screen">
            <i class="material-icons error-icon">mail_outline</i>
            <h3>Email not sent</h3>
            <p>Failed to send invitation to<br>
                <strong>{{ inviteForm.get('email')?.value }}</strong>.<br>
                Please try again.
            </p>
            <div class="success-actions">
                <button class="btn-cancel" (click)="onClose()">Cancel</button>
                <button class="btn-send" (click)="onRetry()">Try Again</button>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="!isSent && !isError">

        <h2 class="dialog-title">Invite a User</h2>

        <mat-dialog-content>
            <form [formGroup]="inviteForm">

                <!-- Email -->
                <div class="field-group">
                    <label>Email address <span class="required-star">*</span></label>
                    <div class="input-wrapper">
                        <input class="field-input"
                            [class.input-error]="inviteForm.get('email')?.invalid && inviteForm.get('email')?.touched"
                            [class.input-success]="inviteForm.get('email')?.valid && inviteForm.get('email')?.touched"
                            formControlName="email" type="email" placeholder="user@example.com"
                            (blur)="inviteForm.get('email')?.markAsTouched()">


                    </div>

                    <div class="error-block"
                        *ngIf="inviteForm.get('email')?.touched && inviteForm.get('email')?.invalid">
                        <div class="field-error" *ngIf="inviteForm.get('email')?.hasError('required')">

                            <span>Email is required</span>
                        </div>
                        <div class="field-error" *ngIf="inviteForm.get('email')?.hasError('pattern')">

                            <span>Invalid format — expected: user@example.com</span>
                        </div>
                    </div>
                </div>

                <!-- Role -->
                <div class="field-group">
                    <label>Role <span class="required-star">*</span></label>
                    <select class="field-input" formControlName="role">
                        <option value="" disabled selected>Select a role</option>
                        <option *ngFor="let r of roles" [value]="r.value">{{ r.label }}</option>
                    </select>

                    <div class="role-description" *ngIf="selectedRole">
                        <i class="material-icons">info</i>
                        <span>{{ selectedRole.description }}</span>
                    </div>
                    <div class="error-block" *ngIf="inviteForm.get('role')?.touched && inviteForm.get('role')?.hasError('required')">
    <div class="field-error">
        <span>Role is required</span>
    </div>
</div>
                </div>

            </form>
        </mat-dialog-content>

        <div class="dialog-actions">
            <button class="btn-cancel" (click)="onClose()">Cancel</button>
           <button class="btn-send" [disabled]="isLoading" (click)="onSend()">
                <span class="btn-content">
                    <span class="loader" *ngIf="isLoading"></span>
                    Send Invitation
                </span>
            </button>
        </div>

    </ng-container>

</div>